import { InjectionToken } from "@angular/core";

export const LOCALE_CONFIG = new InjectionToken("locale.config");

export const Locales = [
  { label: "FI", value: "fi", text: "Finnish" },
  { label: "EN", value: "en", text: "English" },
];

export enum LocaleCode {
  EN = "en",
  FI = "fi",
}
